<template>
  <button class="btn"
    :type="type || 'button'"
    :class="{ disabled, loading: isLoading, wicon: icon }"
    @click="click">
    <icon v-if="icon && !isLoading" :name="icon"/>
    <template v-if="isLoading">
      <loader/>
      {{ loading || '' }}
    </template>
    <slot v-else></slot>
  </button>
</template>

<script>
import Link from '../../mixins/Link.vue'
import { actions } from '../../utils'

export default {
  props: ['disabled', 'isLoading', 'loading', 'icon', 'type', 'track'],
  mixins: [Link],
  methods: {
    click(event) {
      if (this.isLoading || this.disabled) return

      if (this.track) {
        this.GEVENT({ category: 'Button', label: this.track })
      }

      this.go()
      this.$emit('update:isLoading', true)
      this.$emit('click')
    },
    ...actions()
  },
}
</script>

<style lang="scss">
@import '~style/variables';

input[type="sumbmit"], button, .btn {
  @include trans;
  border-radius: $r;
  cursor: pointer;
  display: block;
  font-weight: $semibold;
  font-size: $h6;
  line-height: $lh;
  margin: 0;
  outline: 0;
  padding: 0.5rem 1rem;
  position: relative;
  text-align: center;
  width: 100%;

  // default style
  background: $c-main;
  border: 1px solid $c-main;
  color: #fff;

  // link hover fix
  // &[href]:hover {
  //   color: #fff;
  // }

  // state
  &.loading {
    cursor: default;
  }
  &.wicon {
    padding-right: 1.75rem;
    > .ic {
      float: left;
      padding-right: 0.5rem;
      // left: 0; top: 0;
      // position: absolute;
      // line-height: inherit;
    }
    &.loading {
      padding-right: 1rem;
    }
  }

  // --- shape
  &.no-border {
    background: transparent;
    border-width: 0;
    color: $c-info;
    &:hover {
      color: $c-link;
      text-decoration: underline;
    }
  }
  &.round {
    border-radius: $r-round;
  }
  &.square {
    border-radius: 0;
  }
  &.squarish {
    border-radius: $r;
  }

  // --- theme
  &.inv {
    border-color: $c-main;
    color: $c-main;
    &:hover {
      background: $c-main;
    }
  }
  &.success {
    background: $c-success;
    border-color: $c-success;
    &.inv {
      color: $c-success;
      &:hover {
        background: $c-success-light;
      }
    }
  }
  &.info {
    background: $c-info;
    border-color: $c-info;
    &.inv {
      color: $c-info;
      &:hover {
        background: $c-info-light;
      }
    }
  }
  // TODO: deprecate 'purple'
  &.neutral, &.purple {
    background: $c-neutral;
    border-color: $c-neutral;
    &.inv {
      color: $c-neutral;
    }
  }
  &.warning {
    background: $c-warning;
    border-color: $c-warning;
    &.inv {
      color: $c-warning;
      &:hover {
        color: $c-warning;
      }
    }
    &:hover {
      color: #fff;
    }
  }
  &.danger {
    background: $c-danger;
    border-color: $c-danger;
    &.inv {
      color: $c-danger;
      &:hover {
        background: $c-danger-light;
      }
    }
    &:hover {
      background: $c-danger-light;
      border-color: $c-danger;
      color: $c-danger;
    }
  }
  &.white {
    background: #fff;
    border-color: #fff;
    color: $c-link;
  }
  &.disabled {
    border-color: $c-gray;
    background: $c-light;
    color: $c-text-lightish;
    cursor: default;
    &.inv {
      border-color: $c-text-mid;
      color: $c-text-mid;
    }
  }
  &.inv {
    background: transparent;
    &:hover {
      background: transparent;
    }
  }
  // &.light {
  //   background: $c-info-light;
  //   border-color: $c-info-lightish;
  //   color: $c-info;
  // }
  // used @GroupMember
  &.bland {
    background: transparent;
    border-color: transparent;
    color: $c-info;
  }

  // --- size
  &.lg {
    font-size: 0.9rem;
    letter-spacing: 1px;
    padding: 1rem 4rem;
  }

  &.sm {
    font-size: $h7;
    line-height: $lh;
    padding: 0.5rem 0.5rem;
    &.wicon {
      padding: 0.5rem 1.75rem 0.5rem 0.5rem;
    }
  }

  &.xs {
    font-size: $h7;
    line-height: $lh;
    padding: 0.25rem 1rem;
    &.wicon {
      padding: 0.25rem 1rem 0.25rem 0.5rem;
    }
  }

  // --- align
  &.right {
    float: right;
  }

  // --- display
  &.ib {
    display: inline-block;
    width: auto;
  }
  &.no-pad {
    padding: 0.25rem 0;
  }
  &.link {
    background: transparent;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid $c-link;
    color: $c-link;
    display: inline-block;
    padding: 0;
    width: auto;
    &.right {
      margin-left: 1rem;
    }
    &.gray {
      color: $c-text-mid;
    }
    &.db {
      border-bottom: none;
      width: 100%;
    }
    &:hover {
      color: $c-link-hover;
    }
  }
  &.db {
    display: block;
  }
  // &.lc {
  //   text-transform: none;
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Btn.vue